var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"title":"PDF","width":"100%","src":'/pdfjs/web/viewer.html?file=' + _vm.srcUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }